






import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import AddEditItem from '@/components/add-flows/AddEditItem.vue';
import { GenericItem } from '@/models/items/generic-item-model';
import { ListModel } from '@/models/list-model';
import { ItemModelUtil } from '@/model-utils/item-model-util';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { AbstractItemModel } from '../models/items/abstract-item-model';

@Component({
  components: {
    AddEditItem
  }
})
export default class EditItem extends Vue {
  @Prop(GenericItem) public item: GenericItem;
  @Prop(ListModel) public list?: ListModel;

  myItem: GenericItem = this.item;
  myList: ListModel = this.list;
  itemLoaded: Boolean = false;

  async loadItem() {
    const queryItemId = this.$route.query.itemId as string;
    const items = await ItemModelUtil.hydrateItems([queryItemId])
    if (items.length > 0) {
      this.myItem = items[0] as GenericItem;
    } else {
      throw new Error('missing item ' + queryItemId)
    }
    this.myList = await ListModelUtil.hydrateList(this.myItem.listId)
    this.itemLoaded = true;
  }

  created() {
    const queryItemId = this.$route.query.itemId as string;
    if (!this.item && queryItemId) {
      this.loadItem();
    }

    if (this.item) {
      this.itemLoaded = true;
    }
  }
}
